var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-modal',{attrs:{"size":"md","show":_vm.show,"centered":true},on:{"close":function () {
      _vm.clear();
      _vm.close();
    }}},[_c('mdb-modal-header',[_c('mdb-modal-title',[_vm._v("Bloquear usuário")])],1),_c('mdb-modal-body',[_vm._v(" Tem certeza que deseja bloquear o usuário? ")]),_c('mdb-modal-footer',[_c('mdb-btn',{attrs:{"color":"secondary"},nativeOn:{"click":function($event){return (function () {
          _vm.clear();
          _vm.close();
        })($event)}}},[_vm._v("Não")]),_c('mdb-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.handleBlock($event)}}},[_vm._v("Sim")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }